import { render } from "./Privacy.vue?vue&type=template&id=4467b105"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=4467b105&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__